const doc = [({"en":({"js":({"admin":({"agendas":({"create_card":({"create_agenda":"Create agenda item"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;